// 全局共享数据示例
import { DEFAULT_NAME } from '@/constants';
import { useState, useEffect } from 'react';
import { useModel, history } from '@umijs/max'
import { getAssistantList } from '@/services/AssistantManagement';

export default () => {
  const { initialState, setInitialState } = useModel('@@initialState');
  const [name, setName] = useState<string>(DEFAULT_NAME);
  const [addSquareModal, setAddSquareModal] = useState<boolean>(false);
  const [squareModalInfo, setSquareModalInfo] = useState<any>({});

  useEffect(() => {
    if(!addSquareModal) {
      setSquareModalInfo({})
    }
  }, [addSquareModal])

  const getAssistantListFn = async (id) => {
    const resData = await getAssistantList({ keywords: '' });
    setInitialState({
      ...initialState,
      SquareMenu: resData?.payload?.list || [],
    })
    if (id && !squareModalInfo?.id) history.push(`/assistantInfo/${id}/setting/assistant`);
  }

  return {
    name,
    setName,
    addSquareModal,
    setAddSquareModal,
    getAssistantListFn,
    squareModalInfo, 
    setSquareModalInfo
  };
};

